import React from 'react';
// Modules
import { SimpleGrid, Text, VStack } from '@chakra-ui/react';
// Components
import PromotionCard from './PromotionCard';
import PromotionCardSkeleton from './PromotionCardSkeleton';
import PromotionListSectionContainer from './PromotionListSectionContainer';
// Contexts
import { useAuth } from '../../contexts/AuthContext';
// Firebase
import { usePromotions } from '../../firebase/client-helpers';
// Utils
import { parseError } from '../../utils/helpers';

const PromotionList: React.FC = () => {
  const { points } = useAuth();

  const result = usePromotions({
    filters: [
      {
        condition: '==',
        key: 'active',
        value: true,
      },
      {
        condition: '>',
        key: 'stock',
        value: 0,
      },
    ],
  });

  function renderList(title: string, isPurchaseable: boolean) {
    // eslint-disable-next-line max-len
    const promotions = result.data?.filter((promotion) => (isPurchaseable ? promotion.points <= points : promotion.points > points));

    if (promotions) {
      if (promotions.length === 0) {
        return null;
      }

      return (
        <PromotionListSectionContainer title={title}>
          <SimpleGrid columns={[2, 3, 4]} spacing="4">
            {promotions.map((promotion) => (
              <PromotionCard key={promotion.id} promotion={promotion} />
            ))}
          </SimpleGrid>
        </PromotionListSectionContainer>
      );
    }

    if (result.error) {
      return (
        <PromotionListSectionContainer title={title}>
          <Text>{parseError(result.error)}</Text>
        </PromotionListSectionContainer>
      );
    }

    return (
      <PromotionListSectionContainer title={title}>
        <SimpleGrid columns={[2, 3, 4]} spacing="4">
          {Array.from(new Array(4).keys()).map((item) => (
            <PromotionCardSkeleton key={item} />
          ))}
        </SimpleGrid>
      </PromotionListSectionContainer>
    );
  }

  return (
    <VStack alignItems="stretch" spacing="8">
      {renderList(`Produk di bawah ${points.toLocaleString()} poin`, true)}
      {renderList('Penawaran menarik', false)}
    </VStack>
  );
};

export default PromotionList;
